import { FC, useMemo } from 'react';

import { SellerSidebar } from '@service/seller/containers/SellerSideBar/SellerSidebar';
import { SellerTopNavBar } from '@service/seller/containers/SellerTopNavBar/SellerTopNavBar';
import SellerAccountSettingsPage from '@service/seller/page/SellerAccountSettingsPage';
import SellerBugoSearchPage from '@service/seller/page/SellerBugoSearchPage';
import { SellerCashReceiptPage } from '@service/seller/page/SellerCashReceiptPage';
import SellerCsMemoLogPage from '@service/seller/page/SellerCsMemoLogPage';
import SellerEnquiryPage from '@service/seller/page/SellerEnquiryPage';
import { SellerGusetOrderManagePage } from '@service/seller/page/SellerGusetOrderManagePage';
import { SellerManualRefundRequestPage } from '@service/seller/page/SellerManualRefundRequestPage';
import { SellerTaxInvoiceRequestPage } from '@service/seller/page/SellerTaxInvoiceRequestPage';
import SellerPastDeliverySearchPage from '@service/seller/page/SellerPastDeliverySearchPage';
import SellerReleaseNotePage from '@service/seller/page/SellerReleaseNotePage';
import SellerShopInfoPage from '@service/seller/page/SellerShopInfoPage';
import SellerShopItemInfoManageMainPage from '@service/seller/page/SellerShopItemInfoManageMainPage';
import SellerShopItemManageByShopItemInfoPage from '@service/seller/page/SellerShopItemManageByShopItemInfoPage';
import SellerShopItemManageMainPage from '@service/seller/page/SellerShopItemManageMainPage';
import SellerSettingsPage from '@service/seller/page/SellerSettingsPage';
import { SellerWaitingListPage } from '@service/seller/page/SellerWaitingListPage';
import { useSellerShopHook } from '@shared/api/shop/shop.hook';
import { ErrorFallback } from '@shared/components/ErrorFallback';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes, useParams } from 'react-router-dom';

import { SellerAccountRouter } from './SellerAccountRouter';
import { SellerShopUseShopOrderRouter } from './SellerShopUseShopOrderRouter';

export const ShopRouter: FC = function ShopRouter() {
  // !공지사용x
  // useAnnouncePopupHook();
  const { shopId } = useParams();
  const shopId_ = shopId ?? 'undefined';
  useSellerShopHook(shopId_);

  const topNavBarRender = useMemo(() => {
    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <SellerTopNavBar />
      </ErrorBoundary>
    );
  }, []);

  const sideBarRender = useMemo(() => {
    return <SellerSidebar shopId={shopId_} />;
  }, [shopId_]);

  return (
    <>
      {sideBarRender}
      <div className="min-h-full lg:pl-64">
        <div className="flex flex-1 flex-col">
          {topNavBarRender}
          <Routes>
            <Route path="info" element={<SellerShopInfoPage />} />
            <Route path="*" element={<SellerShopUseShopOrderRouter />} />
            <Route path="past-delivery" element={<SellerPastDeliverySearchPage />} />
            <Route path="bugo-search" element={<SellerBugoSearchPage />} />
            {/* CS 응대 로그 — 자기 매장 메모만 (서버가 스코핑) */}
            <Route path="cs-memo-log" element={<SellerCsMemoLogPage />} />
            <Route path="waiting-list" element={<SellerWaitingListPage />} />
            <Route
              path="tax-invoice-requests"
              element={<SellerTaxInvoiceRequestPage />}
            />
            <Route
              path="manual-refund-requests"
              element={<SellerManualRefundRequestPage />}
            />
            {/* 계좌 입금 건 현금영수증 자진발행 큐 — 페이지 자체가 관리자 전용으로 막는다 */}
            <Route path="cash-receipt" element={<SellerCashReceiptPage />} />
            <Route path="account/*" element={<SellerAccountRouter />} />
            <Route path="account-settings" element={<SellerAccountSettingsPage />} />
            <Route path="settings" element={<SellerSettingsPage />} />
            {/* 화환팀 업데이트 소식 (docs/releases/notes/*.mari-seller.md) */}
            <Route path="release-notes" element={<SellerReleaseNotePage />} />
            {/* 1:1 문의 — 관리자 문의사항 관리 "셀러" 탭으로 */}
            <Route path="enquiry" element={<SellerEnquiryPage />} />
            <Route path="shop-item">
              <Route index element={<SellerShopItemManageMainPage />} />
              <Route
                path="shop-item-info/:shopItemInfoId"
                element={<SellerShopItemManageByShopItemInfoPage />}
              />
            </Route>
            <Route path="guest-order-manage" element={<SellerGusetOrderManagePage />} />
            <Route path="shop-item-info">
              <Route index element={<SellerShopItemInfoManageMainPage />} />
            </Route>
            {/* <Route path="shop-item" element={<ShopItemManagePage />} /> */}
            {/* <Route path="settings" element={<ShopSettingsPage />} /> */}
          </Routes>
        </div>
      </div>
    </>
  );
};
